import { render, staticRenderFns } from "./mRecorder.vue?vue&type=template&id=0f9785f5&scoped=true"
import script from "./mRecorder.vue?vue&type=script&lang=js"
export * from "./mRecorder.vue?vue&type=script&lang=js"
import style0 from "./mRecorder.vue?vue&type=style&index=0&id=0f9785f5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9785f5",
  null
  
)

export default component.exports